
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/milk-dairy-disposal",
      function () {
        return require("private-next-pages/milk-dairy-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/milk-dairy-disposal"])
      });
    }
  